
import BlockContainerAction from "../../actions/blockContainerAction";
import { useEditorStateContext } from "../../contexts/EditorContext";
import { useTreeStateContext } from "../../contexts/TreeContext";
import binarySearchString from "../../utils/binarySearchString";
import cellSizeEditor from "../../data/cellSizeEditor";

function useBlockMagnetPosition() {
    const { setMagnetPosition : setMagnetPositionAction, resetMagnetPosition } = BlockContainerAction();

    const { pathTmp } = useEditorStateContext();
    const { blocksVisible }  = useTreeStateContext();

    const setMagnetPosition = (id) => {
        if(pathTmp == null) return;

        let indexBlock = binarySearchString(blocksVisible, id);
        let block = blocksVisible[indexBlock]

        let x = block.x ;
        let y = block.type.name != 'magic' ? block.y + (block.height - 1) * cellSizeEditor : block.y + (block.height) * cellSizeEditor - cellSizeEditor / 2;

        setMagnetPositionAction(x, y, id);
    }


    return { setMagnetPosition, resetMagnetPosition };
}

export default useBlockMagnetPosition;